import AdsClickIcon from "@mui/icons-material/AdsClick";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import BoltIcon from "@mui/icons-material/Bolt";
import CampaignIcon from "@mui/icons-material/Campaign";
import CelebrationIcon from "@mui/icons-material/Celebration";
import ChatIcon from "@mui/icons-material/Chat";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import ForumIcon from "@mui/icons-material/Forum";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ImageIcon from "@mui/icons-material/Image";
import InsightsIcon from "@mui/icons-material/Insights";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from "@mui/icons-material/Person";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import PsychologyIcon from "@mui/icons-material/Psychology";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import SchoolIcon from "@mui/icons-material/School";
import ShortTextIcon from "@mui/icons-material/ShortText";
import SummarizeIcon from "@mui/icons-material/Summarize";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import TodayIcon from "@mui/icons-material/Today";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import VerifiedIcon from "@mui/icons-material/Verified";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import type { SvgIconComponent } from "@mui/icons-material";

const REFINEMENT_ICONS: Record<string, SvgIconComponent> = {
  RocketLaunch: RocketLaunchIcon,
  Psychology: PsychologyIcon,
  Celebration: CelebrationIcon,
  People: PeopleIcon,
  ShortText: ShortTextIcon,
  AdsClick: AdsClickIcon,
  MenuBook: MenuBookIcon,
  Lightbulb: LightbulbIcon,
  FindInPage: FindInPageIcon,
  PrecisionManufacturing: PrecisionManufacturingIcon,
  Chat: ChatIcon,
  EmojiEvents: EmojiEventsIcon,
  VolunteerActivism: VolunteerActivismIcon,
  Campaign: CampaignIcon,
  Bolt: BoltIcon,
  HelpOutline: HelpOutlineIcon,
  Forum: ForumIcon,
  CompareArrows: CompareArrowsIcon,
  School: SchoolIcon,
  ThumbUp: ThumbUpIcon,
  Verified: VerifiedIcon,
  DirectionsWalk: DirectionsWalkIcon,
  Summarize: SummarizeIcon,
  AutoAwesome: AutoAwesomeIcon,
  Insights: InsightsIcon,
  TrendingUp: TrendingUpIcon,
  Today: TodayIcon,
  Image: ImageIcon,
  FavoriteBorder: FavoriteBorderIcon,
  ReportProblem: ReportProblemIcon,
  FactCheck: FactCheckIcon,
  TaskAlt: TaskAltIcon,
  FormatQuote: FormatQuoteIcon,
  Person: PersonIcon,
};

export function getRefinementIcon(iconName: string | null | undefined): SvgIconComponent | null {
  if (iconName && REFINEMENT_ICONS[iconName]) {
    return REFINEMENT_ICONS[iconName];
  }
  return null;
}
